import { inject, Injectable } from '@angular/core';
import { MessageService } from './message.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TokenExpirationService {
  private timer: ReturnType<typeof setInterval>;
  firstDuration = 12 * 60 * 1000;
  secondDuration = 14 * 60 * 1000;

  private messageService = inject(MessageService);
  private translateService = inject(TranslateService);

  startExpirationTimer(startTime: string) {
    if (!startTime) {
      this.messageService.showError({
        title: this.translateService.instant('tokenExpiration.noToken'),
        text: this.translateService.instant('tokenExpiration.noTokenInfo', {
          actabl: 'Actabl',
        }),
      });

      return;
    }

    let firstWarningShown = false;

    this.timer = setInterval(() => {
      const currentTime = new Date().getTime();
      const elapsedTime = currentTime - parseInt(startTime, 10);

      if (
        !firstWarningShown &&
        elapsedTime >= this.firstDuration &&
        elapsedTime < this.secondDuration
      ) {
        this.messageService.showWarning({
          title: this.translateService.instant(
            'tokenExpiration.aboutToTimeOut',
          ),
          text: this.translateService.instant(
            'tokenExpiration.aboutToTimeOutInfo',
          ),
          buttons: [
            {
              label: this.translateService.instant('tokenExpiration.leaveNow'),
              type: 'cancel',
              actionFn: () => window.close(),
            },
            {
              label: this.translateService.instant(
                'tokenExpiration.continueProcess',
              ),
              type: 'confirm',
            },
          ],
        });

        firstWarningShown = true;
      }

      if (elapsedTime >= this.secondDuration) {
        this.messageService.showError({
          title: this.translateService.instant(
            'tokenExpiration.operationTimedOut',
          ),
          text: this.translateService.instant(
            'tokenExpiration.operationTimedOutInfo',
          ),
          buttons: [
            {
              label: this.translateService.instant('tokenExpiration.close'),
              type: 'cancel',
              actionFn: () => window.close(),
            },
          ],
        });

        this.clearTokenTimer();
      }
    }, 1000);
  }

  clearTokenTimer() {
    clearInterval(this.timer);
    this.timer = null;
  }
}
